import { BRICO } from 'chemistry'

const temporaryProductsWithVlpHidden = ['10450545', '10434561', '10396146', '10324959']
export const checkIfTemporarilyHideVLP = ({ productId, format }) =>
  format === BRICO && temporaryProductsWithVlpHidden.includes(productId)
